export default "__VITE_ASSET__bd334920__"